module.exports = __webpack_public_path__ + "img/Outback_Steakhouse_logo.79f43767.svg";